import { useMemo } from 'react';

import { usePathname } from 'next/navigation';

export const usePageState = (): TPageState => {
  const pathname = usePathname();

  return useMemo(
    () => ({
      isAchRefundsPage: pathname?.includes('ach-refunds'),
      isContactConfirmationPage: pathname?.includes('contacts/confirmation') ?? false,
      isDashboardPage: pathname?.includes('dashboard') ?? false,
      isHomePage: pathname === '/' || pathname === '/dashboard',
      isEditConsumerPage:
        (pathname?.includes('consumers') ?? false) && (pathname?.includes('edit') ?? false),
      isHomeQuotePage: pathname?.includes('home-quotes/') ?? false,
      isNewQuotePage: pathname?.includes('quotes/new') ?? false,
      isSearchPage: pathname?.includes('contacts/search') ?? false,
      isUsersPage: pathname?.includes('users') ?? false,
      isRolesPage: pathname?.includes('roles') ?? false,
      isDealsLogPage: pathname?.includes('deal-log') ?? false,
      isCancelPendingsPage: pathname?.includes('cancel-pendings') ?? false,
      isCancelRewritesPage: pathname?.includes('cancel-rewrites') ?? false,
      isPostDateDeclinesPage: pathname?.includes('post-date-declines') ?? false,
      isWaitForCallPage: pathname?.includes('contacts/waiting') ?? false,
      isWrapUpPage: pathname?.includes('wrap-up') ?? false,
      isScratchpad: pathname?.includes('scratchpad') ?? false,
      isRetentionDiscountsPage: pathname?.includes('retention-discounts') ?? false,
      isTransferOwnershipsPage: pathname?.includes('transfer-ownerships-eds') ?? false,
      isNonEdsTransferOwnershipsPage: pathname?.includes('transfer-ownerships-non-eds') ?? false,
      isPhysicalChecksPage: pathname?.includes('physical-checks') ?? false,
      isVinAuditPage: pathname?.includes('vin-audit') ?? false,
      isMissingDPPage: pathname?.includes('missing-down-payment') ?? false,
      isProRatedRefundPage: pathname?.includes('pro-rated-refund') ?? false,
      isContractTransmittalEventsErrorsPage:
        pathname?.includes('contract-transmittal-events-errors') ?? false,
      isDuplicateSavesPage: pathname?.includes('duplicate-saves') ?? false,
      isFundedFullRefundsPage: pathname?.includes('funded-full-refunds') ?? false,
      isInProgressFulfillmentsPage: pathname?.includes('in-progress-fulfillments') ?? false,
      isInitialFulfillmentsPage: pathname?.includes('initial-fulfillments') ?? false,
    }),
    [pathname],
  );
};

export type TPageState = {
  isAchRefundsPage: boolean;
  isContactConfirmationPage: boolean;
  isDashboardPage: boolean;
  isHomePage: boolean;
  isEditConsumerPage: boolean;
  isHomeQuotePage: boolean;
  isNewQuotePage: boolean;
  isSearchPage: boolean;
  isUsersPage: boolean;
  isRolesPage: boolean;
  isDealsLogPage: boolean;
  isCancelPendingsPage: boolean;
  isCancelRewritesPage: boolean;
  isPostDateDeclinesPage: boolean;
  isWaitForCallPage: boolean;
  isWrapUpPage: boolean;
  isScratchpad: boolean;
  isRetentionDiscountsPage: boolean;
  isNonEdsTransferOwnershipsPage: boolean;
  isTransferOwnershipsPage: boolean;
  isPhysicalChecksPage: boolean;
  isVinAuditPage: boolean;
  isMissingDPPage: boolean;
  isProRatedRefundPage: boolean;
  isContractTransmittalEventsErrorsPage: boolean;
  isDuplicateSavesPage: boolean;
  isFundedFullRefundsPage: boolean;
  isInProgressFulfillmentsPage: boolean;
  isInitialFulfillmentsPage: boolean;
};
